export const NOTIFICATION_DURATION = 3500
